/*
Characters generated with :

emojihash -g ~symbols,~flags,~heart,~office,~people-and-body,~smileys-and-emotion -list

https://github.com/jakub-m/emojihash
```

*/
export const characters = [
  "\u{1F9B0}",
  "\u{1F9B1}",
  "\u{1F9B3}",
  "\u{1F9B2}",
  "\u{1F435}",
  "\u{1F412}",
  "\u{1F98D}",
  "\u{1F9A7}",
  "\u{1F436}",
  "\u{1F415}",
  "\u{1F9AE}",
  "\u{1F429}",
  "\u{1F43A}",
  "\u{1F98A}",
  "\u{1F99D}",
  "\u{1F431}",
  "\u{1F408}",
  "\u{1F981}",
  "\u{1F42F}",
  "\u{1F405}",
  "\u{1F406}",
  "\u{1F434}",
  "\u{1FACE}",
  "\u{1FACF}",
  "\u{1F40E}",
  "\u{1F984}",
  "\u{1F993}",
  "\u{1F98C}",
  "\u{1F9AC}",
  "\u{1F42E}",
  "\u{1F402}",
  "\u{1F403}",
  "\u{1F404}",
  "\u{1F437}",
  "\u{1F416}",
  "\u{1F417}",
  "\u{1F43D}",
  "\u{1F40F}",
  "\u{1F411}",
  "\u{1F410}",
  "\u{1F42A}",
  "\u{1F42B}",
  "\u{1F999}",
  "\u{1F992}",
  "\u{1F418}",
  "\u{1F9A3}",
  "\u{1F98F}",
  "\u{1F99B}",
  "\u{1F42D}",
  "\u{1F401}",
  "\u{1F400}",
  "\u{1F439}",
  "\u{1F430}",
  "\u{1F407}",
  "\u{1F43F}",
  "\u{1F9AB}",
  "\u{1F994}",
  "\u{1F987}",
  "\u{1F43B}",
  "\u{1F428}",
  "\u{1F43C}",
  "\u{1F9A5}",
  "\u{1F9A6}",
  "\u{1F9A8}",
  "\u{1F998}",
  "\u{1F9A1}",
  "\u{1F43E}",
  "\u{1F983}",
  "\u{1F414}",
  "\u{1F413}",
  "\u{1F423}",
  "\u{1F424}",
  "\u{1F425}",
  "\u{1F426}",
  "\u{1F427}",
  "\u{1F54A}",
  "\u{1F985}",
  "\u{1F986}",
  "\u{1F9A2}",
  "\u{1F989}",
  "\u{1F9A4}",
  "\u{1FAB6}",
  "\u{1F9A9}",
  "\u{1F99A}",
  "\u{1F99C}",
  "\u{1FABD}",
  "\u{1FABF}",
  "\u{1F438}",
  "\u{1F40A}",
  "\u{1F422}",
  "\u{1F98E}",
  "\u{1F40D}",
  "\u{1F432}",
  "\u{1F409}",
  "\u{1F995}",
  "\u{1F996}",
  "\u{1F433}",
  "\u{1F40B}",
  "\u{1F42C}",
  "\u{1F9AD}",
  "\u{1F41F}",
  "\u{1F420}",
  "\u{1F421}",
  "\u{1F988}",
  "\u{1F419}",
  "\u{1F41A}",
  "\u{1FAB8}",
  "\u{1FABC}",
  "\u{1F40C}",
  "\u{1F98B}",
  "\u{1F41B}",
  "\u{1F41C}",
  "\u{1F41D}",
  "\u{1FAB2}",
  "\u{1F41E}",
  "\u{1F997}",
  "\u{1FAB3}",
  "\u{1F577}",
  "\u{1F578}",
  "\u{1F982}",
  "\u{1F99F}",
  "\u{1FAB0}",
  "\u{1FAB1}",
  "\u{1F9A0}",
  "\u{1F490}",
  "\u{1F338}",
  "\u{1F4AE}",
  "\u{1FAB7}",
  "\u{1F3F5}",
  "\u{1F339}",
  "\u{1F940}",
  "\u{1F33A}",
  "\u{1F33B}",
  "\u{1F33C}",
  "\u{1F337}",
  "\u{1FABB}",
  "\u{1F331}",
  "\u{1FAB4}",
  "\u{1F332}",
  "\u{1F333}",
  "\u{1F334}",
  "\u{1F335}",
  "\u{1F33E}",
  "\u{1F33F}",
  "\u{2618}",
  "\u{1F340}",
  "\u{1F341}",
  "\u{1F342}",
  "\u{1F343}",
  "\u{1FAB9}",
  "\u{1FABA}",
  "\u{1F344}",
  "\u{1F347}",
  "\u{1F348}",
  "\u{1F349}",
  "\u{1F34A}",
  "\u{1F34B}",
  "\u{1F34C}",
  "\u{1F34D}",
  "\u{1F96D}",
  "\u{1F34E}",
  "\u{1F34F}",
  "\u{1F350}",
  "\u{1F351}",
  "\u{1F352}",
  "\u{1F353}",
  "\u{1FAD0}",
  "\u{1F95D}",
  "\u{1F345}",
  "\u{1FAD2}",
  "\u{1F965}",
  "\u{1F951}",
  "\u{1F346}",
  "\u{1F954}",
  "\u{1F955}",
  "\u{1F33D}",
  "\u{1F336}",
  "\u{1FAD1}",
  "\u{1F952}",
  "\u{1F96C}",
  "\u{1F966}",
  "\u{1F9C4}",
  "\u{1F9C5}",
  "\u{1F95C}",
  "\u{1FAD8}",
  "\u{1F330}",
  "\u{1FADA}",
  "\u{1FADB}",
  "\u{1F35E}",
  "\u{1F950}",
  "\u{1F956}",
  "\u{1FAD3}",
  "\u{1F968}",
  "\u{1F96F}",
  "\u{1F95E}",
  "\u{1F9C7}",
  "\u{1F9C0}",
  "\u{1F356}",
  "\u{1F357}",
  "\u{1F969}",
  "\u{1F953}",
  "\u{1F354}",
  "\u{1F35F}",
  "\u{1F355}",
  "\u{1F32D}",
  "\u{1F96A}",
  "\u{1F32E}",
  "\u{1F32F}",
  "\u{1FAD4}",
  "\u{1F959}",
  "\u{1F9C6}",
  "\u{1F95A}",
  "\u{1F373}",
  "\u{1F958}",
  "\u{1F372}",
  "\u{1FAD5}",
  "\u{1F963}",
  "\u{1F957}",
  "\u{1F37F}",
  "\u{1F9C8}",
  "\u{1F9C2}",
  "\u{1F96B}",
  "\u{1F371}",
  "\u{1F358}",
  "\u{1F359}",
  "\u{1F35A}",
  "\u{1F35B}",
  "\u{1F35C}",
  "\u{1F35D}",
  "\u{1F360}",
  "\u{1F362}",
  "\u{1F363}",
  "\u{1F364}",
  "\u{1F365}",
  "\u{1F96E}",
  "\u{1F361}",
  "\u{1F95F}",
  "\u{1F960}",
  "\u{1F961}",
  "\u{1F980}",
  "\u{1F99E}",
  "\u{1F990}",
  "\u{1F991}",
  "\u{1F9AA}",
  "\u{1F366}",
  "\u{1F367}",
  "\u{1F368}",
  "\u{1F369}",
  "\u{1F36A}",
  "\u{1F382}",
  "\u{1F370}",
  "\u{1F9C1}",
  "\u{1F967}",
  "\u{1F36B}",
  "\u{1F36C}",
  "\u{1F36D}",
  "\u{1F36E}",
  "\u{1F36F}",
  "\u{1F37C}",
  "\u{1F95B}",
  "\u{2615}",
  "\u{1FAD6}",
  "\u{1F375}",
  "\u{1F376}",
  "\u{1F37E}",
  "\u{1F377}",
  "\u{1F378}",
  "\u{1F379}",
  "\u{1F37A}",
  "\u{1F37B}",
  "\u{1F942}",
  "\u{1F943}",
  "\u{1FAD7}",
  "\u{1F964}",
  "\u{1F9CB}",
  "\u{1F9C3}",
  "\u{1F9C9}",
  "\u{1F9CA}",
  "\u{1F962}",
  "\u{1F37D}",
  "\u{1F374}",
  "\u{1F944}",
  "\u{1F52A}",
  "\u{1FAD9}",
  "\u{1F3FA}",
  "\u{1F30D}",
  "\u{1F30E}",
  "\u{1F30F}",
  "\u{1F310}",
  "\u{1F5FA}",
  "\u{1F5FE}",
  "\u{1F9ED}",
  "\u{1F3D4}",
  "\u{26F0}",
  "\u{1F30B}",
  "\u{1F5FB}",
  "\u{1F3D5}",
  "\u{1F3D6}",
  "\u{1F3DC}",
  "\u{1F3DD}",
  "\u{1F3DE}",
  "\u{1F3DF}",
  "\u{1F3DB}",
  "\u{1F3D7}",
  "\u{1F9F1}",
  "\u{1FAA8}",
  "\u{1FAB5}",
  "\u{1F6D6}",
  "\u{1F3D8}",
  "\u{1F3DA}",
  "\u{1F3E0}",
  "\u{1F3E1}",
  "\u{1F3E2}",
  "\u{1F3E3}",
  "\u{1F3E4}",
  "\u{1F3E5}",
  "\u{1F3E6}",
  "\u{1F3E8}",
  "\u{1F3E9}",
  "\u{1F3EA}",
  "\u{1F3EB}",
  "\u{1F3EC}",
  "\u{1F3ED}",
  "\u{1F3EF}",
  "\u{1F3F0}",
  "\u{1F492}",
  "\u{1F5FC}",
  "\u{1F5FD}",
  "\u{26EA}",
  "\u{1F54C}",
  "\u{1F6D5}",
  "\u{1F54D}",
  "\u{26E9}",
  "\u{1F54B}",
  "\u{26F2}",
  "\u{26FA}",
  "\u{1F301}",
  "\u{1F303}",
  "\u{1F3D9}",
  "\u{1F304}",
  "\u{1F305}",
  "\u{1F306}",
  "\u{1F307}",
  "\u{1F309}",
  "\u{2668}",
  "\u{1F3A0}",
  "\u{1F6DD}",
  "\u{1F3A1}",
  "\u{1F3A2}",
  "\u{1F488}",
  "\u{1F3AA}",
  "\u{1F682}",
  "\u{1F683}",
  "\u{1F684}",
  "\u{1F685}",
  "\u{1F686}",
  "\u{1F687}",
  "\u{1F688}",
  "\u{1F689}",
  "\u{1F68A}",
  "\u{1F69D}",
  "\u{1F69E}",
  "\u{1F68B}",
  "\u{1F68C}",
  "\u{1F68D}",
  "\u{1F68E}",
  "\u{1F690}",
  "\u{1F691}",
  "\u{1F692}",
  "\u{1F693}",
  "\u{1F694}",
  "\u{1F695}",
  "\u{1F696}",
  "\u{1F697}",
  "\u{1F698}",
  "\u{1F699}",
  "\u{1F6FB}",
  "\u{1F69A}",
  "\u{1F69B}",
  "\u{1F69C}",
  "\u{1F3CE}",
  "\u{1F3CD}",
  "\u{1F6F5}",
  "\u{1F9BD}",
  "\u{1F9BC}",
  "\u{1F6FA}",
  "\u{1F6B2}",
  "\u{1F6F4}",
  "\u{1F6F9}",
  "\u{1F6FC}",
  "\u{1F68F}",
  "\u{1F6E3}",
  "\u{1F6E4}",
  "\u{1F6E2}",
  "\u{26FD}",
  "\u{1F6DE}",
  "\u{1F6A8}",
  "\u{1F6A5}",
  "\u{1F6A6}",
  "\u{1F6D1}",
  "\u{1F6A7}",
  "\u{2693}",
  "\u{1F6DF}",
  "\u{26F5}",
  "\u{1F6F6}",
  "\u{1F6A4}",
  "\u{1F6F3}",
  "\u{26F4}",
  "\u{1F6E5}",
  "\u{1F6A2}",
  "\u{2708}",
  "\u{1F6E9}",
  "\u{1F6EB}",
  "\u{1F6EC}",
  "\u{1FA82}",
  "\u{1F4BA}",
  "\u{1F681}",
  "\u{1F69F}",
  "\u{1F6A0}",
  "\u{1F6A1}",
  "\u{1F6F0}",
  "\u{1F680}",
  "\u{1F6F8}",
  "\u{1F6CE}",
  "\u{1F9F3}",
  "\u{231B}",
  "\u{23F3}",
  "\u{231A}",
  "\u{23F0}",
  "\u{23F1}",
  "\u{23F2}",
  "\u{1F570}",
  "\u{1F55B}",
  "\u{1F567}",
  "\u{1F550}",
  "\u{1F55C}",
  "\u{1F551}",
  "\u{1F55D}",
  "\u{1F552}",
  "\u{1F55E}",
  "\u{1F553}",
  "\u{1F55F}",
  "\u{1F554}",
  "\u{1F560}",
  "\u{1F555}",
  "\u{1F561}",
  "\u{1F556}",
  "\u{1F562}",
  "\u{1F557}",
  "\u{1F563}",
  "\u{1F558}",
  "\u{1F564}",
  "\u{1F559}",
  "\u{1F565}",
  "\u{1F55A}",
  "\u{1F566}",
  "\u{1F311}",
  "\u{1F312}",
  "\u{1F313}",
  "\u{1F314}",
  "\u{1F315}",
  "\u{1F316}",
  "\u{1F317}",
  "\u{1F318}",
  "\u{1F319}",
  "\u{1F31A}",
  "\u{1F31B}",
  "\u{1F31C}",
  "\u{1F321}",
  "\u{2600}",
  "\u{1F31D}",
  "\u{1F31E}",
  "\u{1FA90}",
  "\u{2B50}",
  "\u{1F31F}",
  "\u{1F320}",
  "\u{1F30C}",
  "\u{2601}",
  "\u{26C5}",
  "\u{26C8}",
  "\u{1F324}",
  "\u{1F325}",
  "\u{1F326}",
  "\u{1F327}",
  "\u{1F328}",
  "\u{1F329}",
  "\u{1F32A}",
  "\u{1F32B}",
  "\u{1F32C}",
  "\u{1F300}",
  "\u{1F308}",
  "\u{1F302}",
  "\u{2602}",
  "\u{2614}",
  "\u{26F1}",
  "\u{26A1}",
  "\u{2744}",
  "\u{2603}",
  "\u{26C4}",
  "\u{2604}",
  "\u{1F525}",
  "\u{1F4A7}",
  "\u{1F30A}",
  "\u{1F383}",
  "\u{1F384}",
  "\u{1F386}",
  "\u{1F387}",
  "\u{1F9E8}",
  "\u{2728}",
  "\u{1F388}",
  "\u{1F389}",
  "\u{1F38A}",
  "\u{1F38B}",
  "\u{1F38D}",
  "\u{1F38E}",
  "\u{1F38F}",
  "\u{1F390}",
  "\u{1F391}",
  "\u{1F9E7}",
  "\u{1F380}",
  "\u{1F381}",
  "\u{1F397}",
  "\u{1F39F}",
  "\u{1F3AB}",
  "\u{1F396}",
  "\u{1F3C6}",
  "\u{1F3C5}",
  "\u{1F947}",
  "\u{1F948}",
  "\u{1F949}",
  "\u{26BD}",
  "\u{26BE}",
  "\u{1F94E}",
  "\u{1F3C0}",
  "\u{1F3D0}",
  "\u{1F3C8}",
  "\u{1F3C9}",
  "\u{1F3BE}",
  "\u{1F94F}",
  "\u{1F3B3}",
  "\u{1F3CF}",
  "\u{1F3D1}",
  "\u{1F3D2}",
  "\u{1F94D}",
  "\u{1F3D3}",
  "\u{1F3F8}",
  "\u{1F94A}",
  "\u{1F94B}",
  "\u{1F945}",
  "\u{26F3}",
  "\u{26F8}",
  "\u{1F3A3}",
  "\u{1F93F}",
  "\u{1F3BD}",
  "\u{1F3BF}",
  "\u{1F6F7}",
  "\u{1F94C}",
  "\u{1F3AF}",
  "\u{1FA80}",
  "\u{1FA81}",
  "\u{1F52B}",
  "\u{1F3B1}",
  "\u{1F52E}",
  "\u{1FA84}",
  "\u{1F3AE}",
  "\u{1F579}",
  "\u{1F3B0}",
  "\u{1F3B2}",
  "\u{1F9E9}",
  "\u{1F9F8}",
  "\u{1FA85}",
  "\u{1FAA9}",
  "\u{1FA86}",
  "\u{2660}",
  "\u{2665}",
  "\u{2666}",
  "\u{2663}",
  "\u{265F}",
  "\u{1F0CF}",
  "\u{1F004}",
  "\u{1F3B4}",
  "\u{1F3AD}",
  "\u{1F5BC}",
  "\u{1F3A8}",
  "\u{1F9F5}",
  "\u{1FAA1}",
  "\u{1F9F6}",
  "\u{1FAA2}",
  "\u{1F453}",
  "\u{1F576}",
  "\u{1F97D}",
  "\u{1F97C}",
  "\u{1F9BA}",
  "\u{1F454}",
  "\u{1F455}",
  "\u{1F456}",
  "\u{1F9E3}",
  "\u{1F9E4}",
  "\u{1F9E5}",
  "\u{1F9E6}",
  "\u{1F457}",
  "\u{1F458}",
  "\u{1F97B}",
  "\u{1FA71}",
  "\u{1FA72}",
  "\u{1FA73}",
  "\u{1F459}",
  "\u{1F45A}",
  "\u{1FAAD}",
  "\u{1F45B}",
  "\u{1F45C}",
  "\u{1F45D}",
  "\u{1F6CD}",
  "\u{1F392}",
  "\u{1FA74}",
  "\u{1F45E}",
  "\u{1F45F}",
  "\u{1F97E}",
  "\u{1F97F}",
  "\u{1F460}",
  "\u{1F461}",
  "\u{1FA70}",
  "\u{1F462}",
  "\u{1FAAE}",
  "\u{1F451}",
  "\u{1F452}",
  "\u{1F3A9}",
  "\u{1F393}",
  "\u{1F9E2}",
  "\u{1FA96}",
  "\u{26D1}",
  "\u{1F4FF}",
  "\u{1F484}",
  "\u{1F48D}",
  "\u{1F48E}",
  "\u{1F507}",
  "\u{1F508}",
  "\u{1F509}",
  "\u{1F50A}",
  "\u{1F4E2}",
  "\u{1F4E3}",
  "\u{1F4EF}",
  "\u{1F514}",
  "\u{1F515}",
  "\u{1F3BC}",
  "\u{1F3B5}",
  "\u{1F3B6}",
  "\u{1F399}",
  "\u{1F39A}",
  "\u{1F39B}",
  "\u{1F3A4}",
  "\u{1F3A7}",
  "\u{1F4FB}",
  "\u{1F3B7}",
  "\u{1FA97}",
  "\u{1F3B8}",
  "\u{1F3B9}",
  "\u{1F3BA}",
  "\u{1F3BB}",
  "\u{1FA95}",
  "\u{1F941}",
  "\u{1FA98}",
  "\u{1FA87}",
  "\u{1FA88}",
  "\u{1F4F1}",
  "\u{1F4F2}",
  "\u{260E}",
  "\u{1F4DE}",
  "\u{1F4DF}",
  "\u{1F4E0}",
  "\u{1F50B}",
  "\u{1FAAB}",
  "\u{1F50C}",
  "\u{1F4BB}",
  "\u{1F5A5}",
  "\u{1F5A8}",
  "\u{2328}",
  "\u{1F5B1}",
  "\u{1F5B2}",
  "\u{1F4BD}",
  "\u{1F4BE}",
  "\u{1F4BF}",
  "\u{1F4C0}",
  "\u{1F9EE}",
  "\u{1F3A5}",
  "\u{1F39E}",
  "\u{1F4FD}",
  "\u{1F3AC}",
  "\u{1F4FA}",
  "\u{1F4F7}",
  "\u{1F4F8}",
  "\u{1F4F9}",
  "\u{1F4FC}",
  "\u{1F50D}",
  "\u{1F50E}",
  "\u{1F56F}",
  "\u{1F4A1}",
  "\u{1F526}",
  "\u{1F3EE}",
  "\u{1FA94}",
  "\u{1F4D4}",
  "\u{1F4D5}",
  "\u{1F4D6}",
  "\u{1F4D7}",
  "\u{1F4D8}",
  "\u{1F4D9}",
  "\u{1F4DA}",
  "\u{1F4D3}",
  "\u{1F4D2}",
  "\u{1F4C3}",
  "\u{1F4DC}",
  "\u{1F4C4}",
  "\u{1F4F0}",
  "\u{1F5DE}",
  "\u{1F4D1}",
  "\u{1F516}",
  "\u{1F3F7}",
  "\u{1F4B0}",
  "\u{1FA99}",
  "\u{1F4B4}",
  "\u{1F4B5}",
  "\u{1F4B6}",
  "\u{1F4B7}",
  "\u{1F4B8}",
  "\u{1F4B3}",
  "\u{1F9FE}",
  "\u{1F4B9}",
  "\u{2709}",
  "\u{1F4E7}",
  "\u{1F4E8}",
  "\u{1F4E9}",
  "\u{1F4E4}",
  "\u{1F4E5}",
  "\u{1F4E6}",
  "\u{1F4EB}",
  "\u{1F4EA}",
  "\u{1F4EC}",
  "\u{1F4ED}",
  "\u{1F4EE}",
  "\u{1F5F3}",
  "\u{270F}",
  "\u{2712}",
  "\u{1F58B}",
  "\u{1F58A}",
  "\u{1F58C}",
  "\u{1F58D}",
  "\u{1F4DD}",
  "\u{1F512}",
  "\u{1F513}",
  "\u{1F50F}",
  "\u{1F510}",
  "\u{1F511}",
  "\u{1F5DD}",
  "\u{1F528}",
  "\u{1FA93}",
  "\u{26CF}",
  "\u{2692}",
  "\u{1F6E0}",
  "\u{1F5E1}",
  "\u{2694}",
  "\u{1F4A3}",
  "\u{1FA83}",
  "\u{1F3F9}",
  "\u{1F6E1}",
  "\u{1FA9A}",
  "\u{1F527}",
  "\u{1FA9B}",
  "\u{1F529}",
  "\u{2699}",
  "\u{1F5DC}",
  "\u{2696}",
  "\u{1F9AF}",
  "\u{1F517}",
  "\u{26D3}",
  "\u{1FA9D}",
  "\u{1F9F0}",
  "\u{1F9F2}",
  "\u{1FA9C}",
  "\u{2697}",
  "\u{1F9EA}",
  "\u{1F9EB}",
  "\u{1F9EC}",
  "\u{1F52C}",
  "\u{1F52D}",
  "\u{1F4E1}",
  "\u{1F489}",
  "\u{1FA78}",
  "\u{1F48A}",
  "\u{1FA79}",
  "\u{1FA7C}",
  "\u{1FA7A}",
  "\u{1FA7B}",
  "\u{1F6AA}",
  "\u{1F6D7}",
  "\u{1FA9E}",
  "\u{1FA9F}",
  "\u{1F6CF}",
  "\u{1F6CB}",
  "\u{1FA91}",
  "\u{1F6BD}",
  "\u{1FAA0}",
  "\u{1F6BF}",
  "\u{1F6C1}",
  "\u{1FAA4}",
  "\u{1FA92}",
  "\u{1F9F4}",
  "\u{1F9F7}",
  "\u{1F9F9}",
  "\u{1F9FA}",
  "\u{1F9FB}",
  "\u{1FAA3}",
  "\u{1F9FC}",
  "\u{1FAE7}",
  "\u{1FAA5}",
  "\u{1F9FD}",
  "\u{1F9EF}",
  "\u{1F6D2}",
  "\u{1F6AC}",
  "\u{26B0}",
  "\u{1FAA6}",
  "\u{26B1}",
  "\u{1F9FF}",
  "\u{1FAAC}",
  "\u{1F5FF}",
  "\u{1FAA7}",
  "\u{1FAAA}",
];
